module.exports = __webpack_public_path__ + "static/assets/1a4799b8789cb6a9b53c7f779c96ff24.jpg";